const VLIBRAS_CDN_ROOT = "https://vlibras.gov.br/app/";

const loadScript = (id, src) => new Promise((resolve, reject) => {
    const existingScript = document.getElementById(id);

    if (existingScript) {
        if (existingScript.dataset.loaded === "true") {
            resolve();
            return;
        }

        existingScript.addEventListener("load", resolve, { once: true });
        existingScript.addEventListener("error", reject, { once: true });
        return;
    }

    const script = document.createElement("script");
    script.id = id;
    script.src = src;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.referrerPolicy = "no-referrer";

    script.addEventListener("load", () => {
        script.dataset.loaded = "true";
        resolve();
    }, { once: true });

    script.addEventListener("error", () => {
        script.remove();
        reject(new Error(`Não foi possível carregar ${src}`));
    }, { once: true });

    document.body.appendChild(script);
});

const createVLibrasWidget = (rootPath) => {
    if (!window.VLibras || typeof window.VLibras.Widget !== "function") {
        throw new Error("VLibras Widget indisponível");
    }

    const previousOnload = window.onload;
    window.onload = null;

    try {
        new window.VLibras.Widget(rootPath);
        const vlibrasOnload = window.onload;
        window.onload = previousOnload;

        if (typeof vlibrasOnload === "function") vlibrasOnload();
    } catch (error) {
        window.onload = previousOnload;
        throw error;
    }
};

const initializeVLibras = async () => {
    const container = document.querySelector("[vw]");

    if (!container || container.dataset.vlibrasInitialized === "true") return;

    container.dataset.vlibrasInitialized = "true";

    try {
        await loadScript("vlibras-widget-cdn", `${VLIBRAS_CDN_ROOT}vlibras-plugin.js`);
        createVLibrasWidget(VLIBRAS_CDN_ROOT);
    } catch (error) {
        container.dataset.vlibrasUnavailable = "true";
    }
};

export const initializeVLibrasAfterLoad = () => {
    if (document.readyState === "complete") {
        initializeVLibras();
        return;
    }

    window.addEventListener("load", initializeVLibras, { once: true });
};
